export default [
	{
		"title": "About the product",
		"questions": [
			{
				"question": "What is DEP?",
				"answer": "DEP is an autonomous trading system that analyzes crypto market microstructure in real time and executes trades automatically. It doesn’t send signals — it trades for you."
			},
			{
				"question": "How does the bot trade?",
				"answer": "It monitors order flow, imbalance, CVD, liquidity density, volatility clusters, and executes trades directly. No indicators, no manual analysis."
			},
			{
				"question": "Does it use indicators or signals?",
				"answer": "No. DEP is not a signal bot — it executes based on structural patterns in market microdata."
			},
			{
				"question": "Can I control the trades manually?",
				"answer": "No, the system is fully autonomous. The only actions available are deposit and withdrawal."
			},
			{
				"question": "Which exchanges does it work with?",
				"answer": "DEP trades through Binance liquidity."
			},
			{
				"question": "Is it decentralized or centralized?",
				"answer": "DEP runs as a centralized AI engine with autonomous execution."
			},
			{
				"question": "Do I need to install an app?",
				"answer": "No. DEP is available directly in Telegram Mini App."
			}
		]
	},
	{
		"title": "Money and fees",
		"questions": [
			{
				"question": "What is the minimum deposit?",
				"answer": "There is no fixed minimum deposit in DEP — you can start with any amount. Just note that each deposit has a fee of 8 USDT + 9%."
			},
			{
				"question": "How much do you charge for deposit?",
				"answer": "Deposit fee: 8 USDT + 9%."
			},
			{
				"question": "How much do you charge for withdrawal?",
				"answer": "Withdrawal fee: 8 USDT + 19%."
			},
			{
				"question": "Are there any hidden fees?",
				"answer": "No hidden fees. All commissions are transparent and fixed."
			},
			{
				"question": "Do I pay a subscription fee?",
				"answer": "No. There are no monthly or yearly subscriptions."
			},
			{
				"question": "What payment methods are supported?",
				"answer": "Deposits and withdrawals are in USDT (TRC-20)."
			},
			{
				"question": "Is there a gas fee to execute trades?",
				"answer": "No. All trading execution costs are covered inside the system."
			}
		]
	},
	{
		"title": "Profit",
		"questions": [
			{
				"question": "How much profit can I expect daily?",
				"answer": "On average, 1–9% daily profit. Results vary depending on market conditions."
			},
			{
				"question": "What is the average monthly profit?",
				"answer": "Historically, 40–150% monthly."
			},
			{
				"question": "Are profits guaranteed?",
				"answer": "No. DEP does not guarantee profit. Both winning and losing trades exist, but historically profits outweigh losses."
			},
			{
				"question": "Do you have losing trades too?",
				"answer": "Yes. Transparency means we publish all trades, profitable and losing."
			},
			{
				"question": "Is compounding possible?",
				"answer": "Yes, profit is added to your balance and continues trading automatically."
			},
			{
				"question": "Can I withdraw profit anytime?",
				"answer": "Yes, withdrawals are available at any time."
			}
		]
	},
	{
		"title": "Withdrawals",
		"questions": [
			{
				"question": "How long do withdrawals take?",
				"answer": "From 10 minutes to 2–3 hours. Maximum up to 7 days in rare cases."
			},
			{
				"question": "Is the withdrawal automatic or manual?",
				"answer": "Automatic. The bot closes open trades and processes withdrawal."
			},
			{
				"question": "Do I need to pass KYC for withdrawal?",
				"answer": "No. DEP does not require KYC for deposits or withdrawals."
			},
			{
				"question": "What if withdrawal is delayed?",
				"answer": "Contact support in Telegram. The system will still process your request."
			},
			{
				"question": "Is there a withdrawal limit?",
				"answer": "No fixed limit, but the bot must close active trades first."
			}
		]
	},
	{
		"title": "Safety",
		"questions": [
			{
				"question": "Is my money safe with DEP?",
				"answer": "All operations are automated and transparent. Users control deposits and withdrawals."
			},
			{
				"question": "Does DEP have access to my exchange account?",
				"answer": "No. The bot operates independently and does not require API keys."
			},
			{
				"question": "Is DEP regulated?",
				"answer": "DEP operates as a software service. There is no financial license."
			},
			{
				"question": "Do you comply with AML / FATF rules?",
				"answer": "Yes. Deposits are only accepted in crypto (USDT), no fiat or cash transfers."
			},
			{
				"question": "What happens if the bot stops working?",
				"answer": "The system is designed for high stability. If trading is paused, funds remain on your balance and are available for withdrawal."
			}
		]
	},
	{
		"title": "Technical",
		"questions": [
			{
				"question": "How do I know the bot is trading?",
				"answer": "You can see live trades and statistics in the app."
			},
			{
				"question": "Can I see the trades?",
				"answer": "Yes. All trades are published with timestamps."
			},
			{
				"question": "Do you publish statistics?",
				"answer": "Yes. Daily, weekly, and monthly performance is open and transparent."
			},
			{
				"question": "Can I connect API keys?",
				"answer": "No, API connection is not needed. The system is fully internal."
			},
			{
				"question": "Is there a mobile app or only Telegram Mini App?",
				"answer": "Only Telegram Mini App at this stage."
			},
			{
				"question": "Do I need VPN to use DEP?",
				"answer": "No. The service works globally."
			}
		]
	},
	{
		"title": "Trust & Experience",
		"questions": [
			{
				"question": "Why should I trust DEP?",
				"answer": "Because all trades and statistics are public and verifiable. No hidden data."
			},
			{
				"question": "How is DEP different from scams?",
				"answer": "We don’t promise guaranteed returns. We show real trades with both profits and losses. Withdrawals are automatic."
			},
			{
				"question": "If it works, why not everyone is using it?",
				"answer": "Adoption takes time. Many people doubt new technologies until they see proof."
			},
			{
				"question": "Do you use your own money in the system?",
				"answer": "Yes. The team tests DEP with real funds."
			},
			{
				"question": "How long has DEP been running?",
				"answer": "Public since January 2026."
			},
			{
				"question": "Can I test it with a small amount first?",
				"answer": "Yes."
			}
		]
	},
	{
		"title": "Community & Support",
		"questions": [
			{
				"question": "Is there a support team?",
				"answer": "Yes. Support is available directly in Telegram."
			},
			{
				"question": "Do you have a Telegram group or channel?",
				"answer": "Yes, both. Channel for updates, group for discussion."
			},
			{
				"question": "Can I contact real users?",
				"answer": "Yes, in the community chat."
			},
			{
				"question": "Do you offer referral bonuses?",
				"answer": "Yes. 5% from each referral deposit."
			},
			{
				"question": "Are there contests or promotions?",
				"answer": "Yes. We run referral contests with prize pools."
			}
		]
	},
	{
		"title": "Doubts & Fears",
		"questions": [
			{
				"question": "Isn’t this too good to be true?",
				"answer": "Many thought the same. That’s why we publish all stats openly."
			},
			{
				"question": "Is DEP a long-term project?",
				"answer": "Yes. DEP is built for the long term. We plan to operate securely at least until 2030, with focus on stability and transparency."
			},
			{
				"question": "What if Binance blocks this bot?",
				"answer": "DEP doesn’t depend on Binance API — it works via liquidity analysis."
			},
			{
				"question": "I was scammed before, how are you different?",
				"answer": "We don’t take money manually, don’t promise fixed returns, and all trades are verifiable."
			},
			{
				"question": "What happens in a bear market?",
				"answer": "DEP trades both directions. It can profit in bull and bear conditions."
			},
			{
				"question": "What happens if everyone uses DEP?",
				"answer": "Markets adapt, but inefficiencies remain. Not all liquidity reacts at once."
			}
		]
	}
]
